import { AxiosResponse } from 'axios';

import { API_BASE_PATH } from '@/config';
import { axios } from '@/lib/axios';

export const downloadReviewedTimeOffXLS = (
  page?: string,
  sort?: string,
  type?: string,
  createdBetween?: string,
  status = 'accepted,rejected,canceled'
): Promise<AxiosResponse<Blob, any>> =>
  axios.get(`${API_BASE_PATH}/workers/time-off`, {
    params: {
      sort,
      page,
      'filter[status]': status,
      'filter[type]': type,
      'filter[createdBetween]': createdBetween,
    },
    headers: {
      accept: 'application/octet-stream',
    },
    responseType: 'blob',
  });
